export function getEnumKeyByEnumValue<
  TEnumKey extends string,
  TEnumVal extends string | number
>(myEnum: { [key in TEnumKey]: TEnumVal }, enumValues: TEnumVal[]): string[] {
  return (Object.keys(myEnum) as TEnumKey[]).filter((x) =>
    enumValues.includes(myEnum[x]),
  );
}

export default getEnumKeyByEnumValue;
